<ngx-smart-modal #analysisDefinition
    [identifier]="modalType" 
    [title]="title"
    class="analysisDefinition-modal"
    closable="false" 
    dismissible="false" 
    escapable="false"
    [closeButtonText]="closeButtonText" 
    [confirmButtonText]="confirmButtonText" 
    [disableConfirmButton]="isAnalysisDefinitionIllumina || !avdFormGroup.valid">
    <form [formGroup]="avdFormGroup" novalidate ng-submit="onCreateNewKitClick()" autocomplete="off">
        <div class="form-group">
            <h4 class="form-group-title avd-mandatory-field">Name</h4>
            <lib-form-field [label]="" hint="Maximum 255 characters" [isValidateOnTouch]="true"
                [errorMessage]="getErrorMessage('name')">
                <input lib-input type="text" formControlName="name" data-cy="name">
            </lib-form-field>
        </div>
        <div class="form-group">
            <h4 class="form-group-title avd-mandatory-field">Display Name</h4>
            <lib-form-field [label]="" hint="Maximum 255 characters" [isValidateOnTouch]="true"
                [errorMessage]="getErrorMessage('displayName')">
                <input lib-input type="text" formControlName="displayName" data-cy="displayName">
            </lib-form-field>
        </div>
        <div class="form-group">
            <h4 class="form-group-title">Organization</h4>
            <lib-form-field [label]="" hint="Maximum 255 characters" [isValidateOnTouch]="true"
                [errorMessage]="getErrorMessage('organization')">
                <input lib-input type="text" formControlName="organization" data-cy="organization">
            </lib-form-field>
        </div>
        <div class="form-group">
            <h4 class="form-group-title">Description</h4>
            <lib-form-field [label]="" hint="Maximum 8192 characters" [isValidateOnTouch]="true"
                [errorMessage]="getErrorMessage('description')">
                <input lib-input type="text" formControlName="description" data-cy="description">
            </lib-form-field>
        </div>
    
        <h4 class="form-group-title table-title">Analysis Versions</h4>
        <button lib-btn secondary small type="button" class="new-version-btn"
            *ngIf="!isAnalysisDefinitionIllumina" (click)="onAddVersionClick()">
            Add Version
        </button>
        <lib-data-table
        #analysisVersionTable
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        showPageSizeController="enable"
        >
        </lib-data-table>
    </form>
    <section #wrapperLoader class="wrapper" [ngClass]="{active: isLoading}" *ngIf="isLoading"
             data-cy="progress-overlay-wrapper">
    </section>
    <lib-progress class="" id="analysis-definition-spinner" #loadingSpinner
      [loader]="false" [spinner]="true" spinnerPosition="center" [fixed]="true" data-cy="progress-overlay-spinner">
    </lib-progress>
</ngx-smart-modal>
